<template>
	<div>
		<v-icon small class="mr-2">mdi-pencil</v-icon>
		<v-dialog v-model="showDialog" width="500">
			<template v-slot:activator="{ on, attrs }">
				<v-icon small v-bind="attrs" v-on="on">mdi-delete</v-icon>
			</template>

			<v-card>
				<v-card-title class="headline grey lighten-2">{{$t('common.delete-confirmation')}}</v-card-title>

				<v-card-text class="mt-3">{{deleteMessage}}</v-card-text>

				<v-divider></v-divider>

				<v-card-actions>
					<v-btn color="normal" text @click="showDialog = false">{{$t('common.cancel')}}</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="confirmAndDismissDialog">{{$t('common.delete')}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
	name: 'RecordActionColumn',
	props: {
		deleteMessage: {
			type: String,
			required: true,
		},
		onDeleteConfirmation: {
			type: Function,
			required: true,
		},
	},
	data: () => ({
		showDialog: false,
	}),
	methods: {
		confirmAndDismissDialog() {
			this.showDialog = false;
			this.onDeleteConfirmation();
		},
	},
};
</script>